import {User} from '@hconnect/apiclient'
import React, {Dispatch, SetStateAction, useState} from 'react'

type UseUserContextReturn = {
  loggedUser: User | null
  setLoggedUser: Dispatch<SetStateAction<User | null>>
}

type UserContextProviderProps = {
  initialUserValue: User | null
  children?: React.ReactNode
}

const context = React.createContext<UseUserContextReturn | undefined>(undefined)

export const UserContextProvider: React.FC<UserContextProviderProps> = ({
  initialUserValue,
  children
}) => {
  const [loggedUser, setLoggedUser] = useState<User | null>(initialUserValue)

  const memoizedValue = React.useMemo(
    () => ({
      loggedUser,
      setLoggedUser
    }),
    [loggedUser]
  )

  return <context.Provider value={memoizedValue}>{children}</context.Provider>
}

export function useUserContext(): UseUserContextReturn {
  const ctx = React.useContext(context)
  if (ctx === undefined) {
    throw new Error('useUserContext must be used within a UserContextProvider')
  }
  return ctx
}
